/**
 * Espera curta DENTRO de um controle (contrato `Spinner` do catalogo do design system).
 *
 * PROMOVIVEL: nao sabe o que esta carregando.
 *
 * Nunca aparece sozinho. O design system corta animacao em `prefers-reduced-motion`, entao um giro
 * mudo deixaria a pessoa sem informacao nenhuma - por isso o componente sempre vem acompanhado de
 * um rotulo (visivel ou so para leitor de tela), e o giro e enfeite.
 *
 * TERCEIRA COPIA (NIG, Report Viewer, e aqui). A regra escrita nas duas anteriores era subir para
 * `@ledger-glass/react` nesta hora; a decisao de 2026-09-29 foi copiar mais uma vez e promover
 * depois (spec 0008, "Promocao ao pacote"), para entregar o manager sem mexer no repositorio do
 * design system nem em producao.
 *
 * Isto e DIVIDA REGISTRADA, nao regra abandonada: a partir daqui sao tres implementacoes da mesma
 * peca evoluindo em paralelo. Quem for promover, compare as tres primeiro - hoje sao identicas por
 * construcao, e o que tiver divergido dira o que cada app precisou.
 */

export interface SpinnerProps {
  /** O que esta acontecendo. Vai para o leitor de tela e, com `showLabel`, para a tela. */
  label: string
  showLabel?: boolean
  size?: 'small' | 'default'
}

export function Spinner({ label, showLabel = false, size = 'default' }: SpinnerProps) {
  return (
    <span className={`spinner spinner--${size}`} role="status">
      <span className="spinner__disc" aria-hidden="true" />
      <span className={showLabel ? 'spinner__label' : 'sr-only'}>{label}</span>
    </span>
  )
}
